import { useQuery } from '@tanstack/react-query';

import { ratePlanQueryKeys } from '~/hooks/apis/reservation/useOfferRatePlans';

import ReservationService from '~/services/ReservationService';

export function useGetRatePlan(ratePlanId: string) {
  return useQuery({
    queryKey: ratePlanQueryKeys.detail(ratePlanId),
    queryFn: async () => (await ReservationService.getRatePlan(ratePlanId)).result,
  });
}
